/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags ProductLists
 */
export const ImportVariantsInProductListContentType = 'multipart/form-data' as const;
export type ImportVariantsInProductListRequest = {
    /**
     * @format binary
     */
    file: string;
};
export type ImportVariantsInProductListResponses = {};
export type ImportVariantsInProductListResponseSuccess = undefined;
export type ImportVariantsInProductListSearchParams = undefined;
export type ImportVariantsInProductListPathParameters = {
    list_id: string;
};
export const ImportVariantsInProductListUrl = '/product-lists/{list_id}/variants/import/async' as const;
export const ImportVariantsInProductListMethod = 'POST' as const;
export const getImportVariantsInProductListUrl = (params: ImportVariantsInProductListPathParameters) =>
    ImportVariantsInProductListUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof ImportVariantsInProductListPathParameters) => String(params[param])
    );
